import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import { FiCheck, FiArrowRight } from 'react-icons/fi';
import styles from './NewStore.module.css';
import AxiosUrl from '../AxiosUrl';
import AddDomainModal from './Modal/AddDomain/AddDomain';
import StoreDescription from './Modal/StoreDescription/StoreDescription';
import Contact from './Modal/Contact/Contact';
import Delivery from './Modal/DeliveryCharge/DeliveryCharge';
import BkashNagadRocket from './Modal/BkashNagadRocket/BkashNagadRocket';
import BkashPaymentAPI from './Modal/BkashPaymentAPI/BkashPaymentAPI';
import RocketPaymentAPI from './Modal/RocketPaymentAPI/RocketPaymentAPI';
import NagadPaymentAPI from './Modal/NagadPaymentAPI/NagadPaymentAPI';
import PathaoCourierAPI from './Modal/PathaoCourierAPI/PathaoCourierAPI';
// import Policy from "./Policy";
import SteadFastCourierAPI from './Modal/SteadFastCourierAPI/SteadFastCourierAPI';
import Tracking from './Modal/Tracking/Tracking';
import HomeLayout from './HomeLayout/HomeLayout';
import HomeSections from './HomeSections/HomeSections';
import axios from 'axios';

function isValidSubdomain(subdomain) {
    // Allowing additional characters like commas, colons, and asterisks
    const subdomainRegex = /^(?!-)[A-Za-z0-9-,:*]{1,63}(?<!-)$/;
    return subdomainRegex.test(subdomain);
}

// Any image the browser can open (PNG, JPG, WebP, GIF, SVG, ICO), any size or
// shape → a FAVICON_SIZE × FAVICON_SIZE PNG: aspect ratio kept, centred, the
// spare sides transparent. Resolves { blob, width, height } (the original size).
const FAVICON_SIZE = 512;
const isSvgFile = (file) => file.type === 'image/svg+xml' || /\.svg$/i.test(file.name || '');
function convertFavicon(file) {
    return new Promise((resolve, reject) => {
        // An SVG only opens with its own type; some systems give .svg files none.
        const source = isSvgFile(file) && file.type !== 'image/svg+xml' ? new Blob([file], { type: 'image/svg+xml' }) : file;
        const src = URL.createObjectURL(source);
        const img = new Image();
        img.onload = () => {
            try {
                // SVGs without a set size report 0 × 0: draw them at full size.
                const width = img.naturalWidth || FAVICON_SIZE;
                const height = img.naturalHeight || FAVICON_SIZE;
                const canvas = document.createElement('canvas');
                canvas.width = FAVICON_SIZE;
                canvas.height = FAVICON_SIZE;
                const ctx = canvas.getContext('2d');
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';
                const scale = Math.min(FAVICON_SIZE / width, FAVICON_SIZE / height);
                const w = Math.round(width * scale);
                const h = Math.round(height * scale);
                ctx.drawImage(img, Math.round((FAVICON_SIZE - w) / 2), Math.round((FAVICON_SIZE - h) / 2), w, h);
                canvas.toBlob((blob) => {
                    URL.revokeObjectURL(src);
                    if (blob) resolve({ blob, width, height });
                    else reject(new Error('convert failed'));
                }, 'image/png');
            } catch (err) {
                URL.revokeObjectURL(src);
                reject(err);
            }
        };
        img.onerror = () => {
            URL.revokeObjectURL(src);
            reject(new Error('not an image'));
        };
        img.src = src;
    });
}

function NewStore() {
    const CreateStore = localStorage.getItem('CreateStore');
    const [addDomainModal, setAddDomainModal] = useState(false);
    const [DescriptionModal, setDescriptionModal] = useState(false);
    const [ContactModal, setContactModal] = useState(false);
    const [DeliveryModal, setDeliveryModal] = useState(false);
    const [BNRModal, setBNRModal] = useState(false);
    const [BkashApiModal, setBkashApiModal] = useState(false);
    const [RocketApiModal, setRocketApiModal] = useState(false);
    const [NagadApiModal, setNagadApiModal] = useState(false);
    const [PathaoApiModal, setPathaoApiModal] = useState(false);
    const [SteadFastApiModal, setSteadFastApiModal] = useState(false);
    const [TrackingModal, setTrackingModal] = useState(false);

    const [storeData, setStoreData] = useState();
    const [Refresh, setRefresh] = useState(1);
    const uid = localStorage.getItem('id');
    const [dataLoading, setDataLoading] = useState(true);
    const [loadingVerify, setLoadingVerify] = useState(false);
    const [loadingMeta, setLoadingMeta] = useState(false);
    const [favicon, setFavicon] = useState(null);
    const [faviconUrl, setFaviconUrl] = useState(null);
    const [storeLoading, setStoreLoading] = useState(false);
    const [storeName, setStoreName] = useState();
    // Nameservers come from /get-dns-config (DefaultDNSConfig.nameservers); never build them from rootDomain
    const [nameservers, setNameservers] = useState(['ns1.custom-dns.com', 'ns2.custom-dns.com']);
    const [primaryIP, setPrimaryIP] = useState('202.5.53.41');
    const [dnsConfig, setDnsConfig] = useState(null);

    // Favicon: any image of any size or shape is converted here to a square
    // 512×512 PNG (picture centred, sides transparent) before it is uploaded.
    // Browsers, phone home screens and the web app manifest all need square
    // icons; 512×512 covers every size they ask for (an uploaded 64×64 icon
    // was declared as 192/512 in the manifest and Chrome rejected it).
    const [faviconBusy, setFaviconBusy] = useState('');
    const [faviconNote, setFaviconNote] = useState(null);
    const handleFaviconChange = async (e) => {
        const file = e.target.files && e.target.files[0];
        if (faviconNote) URL.revokeObjectURL(faviconNote.preview);
        setFavicon(null);
        setFaviconNote(null);
        if (!file) return;
        setFaviconBusy('converting');
        try {
            const { blob, width, height } = await convertFavicon(file);
            const converted = new File([blob], 'favicon.png', { type: 'image/png' });
            setFavicon(converted);
            // An SVG is drawn from its vector shapes, so its size never makes it blurry.
            const svg = isSvgFile(file);
            const notes = [svg
                ? `Ready: converted from SVG to a ${FAVICON_SIZE} × ${FAVICON_SIZE} px PNG.`
                : `Ready: converted from ${width} × ${height} px to a ${FAVICON_SIZE} × ${FAVICON_SIZE} px PNG.`];
            if (width !== height) notes.push('Your image is not square, so it is centred with transparent sides.');
            if (!svg && Math.max(width, height) < FAVICON_SIZE) notes.push(`Your image is small, so the icon may look blurry. A ${FAVICON_SIZE} × ${FAVICON_SIZE} px (or larger) image looks sharpest.`);
            setFaviconNote({ preview: URL.createObjectURL(blob), notes, warn: notes.length > 1 });
        } catch (err) {
            toast.error('This file could not be opened as an image. Please choose a PNG, JPG, WebP, GIF, SVG or ICO file.');
            e.target.value = '';
        } finally {
            setFaviconBusy('');
        }
    };

    useEffect(() => {
        setDataLoading(true);
        AxiosUrl.get(`/get-domain-new/${uid}`)
            .then((data) => {
                setStoreData(data.data);
                setFaviconUrl(data.data.favicon);
            })
            .catch((error) => {
                console.log(error.response.data);
            })
            .finally(() => {
                setDataLoading(false);
            });
    }, [Refresh]);

    // Fetch DNS config for nameservers and primaryIP
    useEffect(() => {
        AxiosUrl.get('/get-dns-config')
            .then((response) => {
                if (response.data?.success && response.data?.data) {
                    setDnsConfig(response.data.data);
                    const hosts = (response.data.data.nameservers || [])
                        .map((ns) => ns.hostname)
                        .filter(Boolean);
                    if (hosts.length > 0) {
                        setNameservers(hosts);
                    }
                    if (response.data.data.primaryIP) {
                        setPrimaryIP(response.data.data.primaryIP);
                    }
                }
            })
            .catch((error) => {
                console.log('Failed to fetch DNS config:', error);
            });
    }, []);

    const handleFaviconUpload = async () => {
        if (faviconBusy) return;
        if (!favicon) {
            toast.error('Please choose an image for the favicon first.');
            return;
        }
        setFaviconBusy('uploading');
        try {
            // /upload-normal stores the file as it is. (The CDN's /upload/favicon
            // shrinks every favicon to 64×64, too small for a phone home screen
            // or an installed app.)
            const formData = new FormData();
            formData.append('photo', favicon);
            let url;
            try {
                const up = await axios.post(`https://cdn.ecomtechbd.com/upload-normal`, formData);
                url = typeof up.data === 'string' ? up.data : '';
            } catch (err) {
                throw new Error('The image could not be uploaded. Please check your internet connection and try again.');
            }
            if (!/^https?:\/\//.test(url)) {
                throw new Error('The image could not be uploaded. Please try again.');
            }
            let res;
            try {
                res = (await AxiosUrl.post(`/favicon/${uid}`, { favicon: url })).data;
            } catch (err) {
                const msg = err && err.response && err.response.data;
                throw new Error(typeof msg === 'string' && msg ? msg : (msg && msg.error) || 'The favicon could not be saved. Please try again.');
            }
            if (res && res.error) throw new Error(String(res.error));
            setFaviconUrl((res && res.favicon) || url);
            setFavicon(null);
            if (faviconNote) URL.revokeObjectURL(faviconNote.preview);
            setFaviconNote(null);
            const input = document.getElementById('ej-favicon-input');
            if (input) input.value = '';
            if (res && res.message === 'Failed') {
                toast.warn('Favicon saved. Your store page will show it within a few minutes.');
            } else {
                toast.success('Favicon updated. Refresh your store to see it.');
            }
            setRefresh((r) => r + 1);
        } catch (err) {
            toast.error(err.message || 'Favicon upload failed. Please try again.');
        } finally {
            setFaviconBusy('');
        }
    };

    const handleVerify = (domain) => {
        setLoadingVerify(true);
        AxiosUrl.post(`/verify-domain/${uid}`, { domain })
            .then((data) => {
                toast.success(data.data);
                setRefresh(Refresh + 1);
                setLoadingVerify(false);
            })
            .catch((error) => {
                toast.error(error.response.data);
                setLoadingVerify(false);
            });
    };

    const AlartSubmit = (domain) => {
        setRefresh(false);
        confirmAlert({
            title: 'DELETE CONFIRMATION',
            message: 'Are you sure to delete the domain.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => handleDelete(domain),
                },
                {
                    label: 'No',
                    onClick: () => null,
                },
            ],
        });
    };

    const handleDelete = (domain) => {
        AxiosUrl.post(`/delete-domain/${uid}`, { domain })
            .then((data) => {
                toast.success(data.data);
                setStoreData();
                setRefresh(Refresh + 1);
            })
            .catch((error) => {
                toast.error(error.response.data);
            });
    };

    const handleMeta = () => {
        if (storeData.metaTitle) {
            setLoadingMeta(true);
            AxiosUrl.post(`/update-meta/${uid}`, storeData)
                .then((data) => {
                    toast.success(data.data);
                    setRefresh(Refresh + 1);
                    setLoadingMeta(false);
                })
                .catch((error) => {
                    toast.error(error.response.data);
                    setLoadingMeta(false);
                });
        } else {
            toast.error('Please set metaTitle, Description and keywords');
        }
    };

    const CreateStoreSubmit = () => {
        setStoreLoading(true);
        if (!storeName) {
            toast.error('পেজ অথবা কোম্পানির নাম লিখুন');
            setStoreLoading(false);
            return;
        }

        // Validate subdomain
        if (!isValidSubdomain(storeName)) {
            toast.error('Invalid subdomain. Please enter a valid subdomain.');
            setStoreLoading(false);
            return;
        }

        AxiosUrl.post(`/add-domain-new/${uid}`, {
            uid,
            storeName,
            sub: 'true',
        })
            .then((data) => {
                console.log(data.data);
                if (data.data === 'Domain and SubDomain added successfully.') {
                    toast.success(data.data);
                    localStorage.setItem('CreateStore', true);
                }
                setRefresh(Refresh + 1);
                setStoreLoading(false);
            })
            .catch((error) => {
                toast.error(error.response.data);
                setStoreLoading(false);
            });
    };
    if (CreateStore == 'false')
        return (
            <>
                <div className={styles['store-creation-main']}>
                    <ToastContainer />
                    <p>
                        1 মিনিটের মধ্যে আপনার ই কমার্স ওয়েবসাইট তৈরী করতে নিচে
                        আপনার ফেইসবুক পেজ অথবা কোম্পানির নাম লিখুন উধাহরণ Ecom
                        Tech লিখে নিচে সেট স্টোর বাটন এ ক্লিক করুন
                    </p>
                    <div className={styles['store-input-submit']}>
                        <input
                            placeholder="পেজ অথবা কোম্পানির নাম লিখুন"
                            value={storeName}
                            onChange={(e) => setStoreName(e.target.value)}
                        />
                        <button onClick={CreateStoreSubmit}>
                            {storeLoading ? 'CREATEING STORE..' : 'SET STORE'}
                        </button>
                    </div>
                </div>
            </>
        );

    return (
        <>
            {addDomainModal && (
                <AddDomainModal
                    setAddDomainModal={setAddDomainModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                />
            )}
            {DescriptionModal && (
                <StoreDescription
                    setDescriptionModal={setDescriptionModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            {ContactModal && (
                <Contact
                    setContactModal={setContactModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            {DeliveryModal && (
                <Delivery
                    setDeliveryModal={setDeliveryModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            {BNRModal && (
                <BkashNagadRocket
                    setBNRModal={setBNRModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            {BkashApiModal && (
                <BkashPaymentAPI
                    setBkashApiModal={setBkashApiModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            {RocketApiModal && (
                <RocketPaymentAPI
                    setRocketApiModal={setRocketApiModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            {NagadApiModal && (
                <NagadPaymentAPI
                    setNagadApiModal={setNagadApiModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            {PathaoApiModal && (
                <PathaoCourierAPI
                    setPathaoApiModal={setPathaoApiModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            {SteadFastApiModal && (
                <SteadFastCourierAPI
                    setSteadFastApiModal={setSteadFastApiModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            {TrackingModal && (
                <Tracking
                    setTrackingModal={setTrackingModal}
                    setRefresh={setRefresh}
                    Refresh={Refresh}
                    Data={storeData}
                />
            )}
            <ToastContainer />
            {dataLoading ? (
                <div className={styles['main-new-store']}>
                    <div className={styles['content-wrapper']}>
                        {/* Store Overview Skeleton */}
                        <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:'12px',marginBottom:'24px',overflow:'hidden'}}>
                            <div className={styles['new-store-title']}>
                                Store Overview
                            </div>
                            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit, minmax(250px, 1fr))',gap:'24px',padding:'24px'}}>
                                {[1,2,3].map(i => (
                                    <div key={i} style={{background:'#fff',padding:'20px',borderRadius:'8px',border:'1px solid #e1e3e5'}}>
                                        <div className={styles.skeleton} style={{width:'100px',height:'16px',marginBottom:'16px'}}></div>
                                        <div className={styles.skeleton} style={{width:'100%',height:'40px',borderRadius:'6px',marginBottom:'12px'}}></div>
                                        <div className={styles.skeleton} style={{width:'100%',height:'38px',borderRadius:'8px'}}></div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Domain Settings Skeleton */}
                        <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:'12px',marginBottom:'24px',overflow:'hidden'}}>
                            <div className={styles['new-store-add-domain-title']}>
                                <span className={styles['new-store-title']}>
                                    Domain Settings
                                </span>
                                <button
                                    onClick={() => setAddDomainModal(true)}
                                    className={styles['new-store-add-domain-btn']}
                                >
                                    + Add Domain
                                </button>
                            </div>
                            <div style={{padding:'16px 24px'}}>
                                <div style={{display:'grid',gridTemplateColumns:'minmax(200px,1fr) 2fr auto',gap:'24px',alignItems:'center',padding:'16px 0'}}>
                                    <div className={styles.skeleton} style={{width:'120px',height:'16px'}}></div>
                                    <div className={styles.skeleton} style={{width:'100%',height:'44px',borderRadius:'6px'}}></div>
                                    <div className={styles.skeleton} style={{width:'120px',height:'40px',borderRadius:'8px'}}></div>
                                </div>
                            </div>
                        </div>

                        {/* Store Information Skeleton */}
                        <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:'12px',marginBottom:'24px',overflow:'hidden'}}>
                            <div className={styles['new-store-title']}>
                                Store Information
                            </div>
                            {['Store Logo','Store Name','MetaTitle','MetaDescription','MetaKeywords'].map((_, i) => (
                                <div key={i} style={{display:'grid',gridTemplateColumns:'minmax(200px,1fr) 2fr auto',gap:'24px',alignItems:'center',padding:'16px 24px',borderBottom:'1px solid #f1f2f3'}}>
                                    <div className={styles.skeleton} style={{width: i===0 ? '200px' : '110px',height:'16px'}}></div>
                                    <div className={styles.skeleton} style={{width:'100%',height: i===0 ? '70px' : '44px',borderRadius:'6px'}}></div>
                                    <div className={styles.skeleton} style={{width:'120px',height:'40px',borderRadius:'8px'}}></div>
                                </div>
                            ))}
                            <div style={{display:'flex',justifyContent:'flex-end',padding:'20px 24px',borderTop:'1px solid #f1f2f3'}}>
                                <div className={styles.skeleton} style={{width:'150px',height:'40px',borderRadius:'8px'}}></div>
                            </div>
                        </div>

                        {/* Favicon Skeleton */}
                        <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:'12px',marginBottom:'24px',overflow:'hidden'}}>
                            <div className={styles['new-store-title']}>
                                Favicon
                            </div>
                            <div style={{display:'grid',gridTemplateColumns:'minmax(200px,1fr) 2fr auto auto',gap:'24px',alignItems:'center',padding:'16px 24px'}}>
                                <div className={styles.skeleton} style={{width:'180px',height:'16px'}}></div>
                                <div className={styles.skeleton} style={{width:'80px',height:'50px',borderRadius:'6px'}}></div>
                                <div className={styles.skeleton} style={{width:'140px',height:'40px',borderRadius:'8px'}}></div>
                                <div className={styles.skeleton} style={{width:'90px',height:'40px',borderRadius:'8px'}}></div>
                            </div>
                        </div>

                        {/* Contact Information Skeleton */}
                        <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:'12px',marginBottom:'24px',overflow:'hidden'}}>
                            <div className={styles['new-store-title']}>
                                Contact Information
                            </div>
                            {['Mobile','Email','Address','WhatsApp','Facebook'].map((_, i) => (
                                <div key={i} style={{display:'grid',gridTemplateColumns:'minmax(200px,1fr) 2fr auto',gap:'24px',alignItems:'center',padding:'16px 24px',borderBottom:'1px solid #f1f2f3'}}>
                                    <div className={styles.skeleton} style={{width: [80,60,80,90,90][i]+'px',height:'16px'}}></div>
                                    <div className={styles.skeleton} style={{width:'100%',height:'44px',borderRadius:'6px'}}></div>
                                    <div className={styles.skeleton} style={{width:'120px',height:'40px',borderRadius:'8px'}}></div>
                                </div>
                            ))}
                        </div>

                        {/* Payment Settings Skeleton */}
                        <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:'12px',marginBottom:'24px',overflow:'hidden'}}>
                            <div className={styles['new-store-title']}>
                                Payment Settings
                            </div>
                            {[1,2,3].map(i => (
                                <div key={i} style={{display:'grid',gridTemplateColumns:'minmax(200px,1fr) 2fr auto',gap:'24px',alignItems:'center',padding:'16px 24px',borderBottom:'1px solid #f1f2f3'}}>
                                    <div className={styles.skeleton} style={{width:'100px',height:'16px'}}></div>
                                    <div className={styles.skeleton} style={{width:'100%',height:'44px',borderRadius:'6px'}}></div>
                                    <div className={styles.skeleton} style={{width:'120px',height:'40px',borderRadius:'8px'}}></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
            <div className={styles['main-new-store']}>
                <div className={styles['content-wrapper']}>
                    {/* Store Section Start */}
                    <div className={styles['new-store-container']}>
                        <div className={styles['new-store-title']}>
                            Store Overview
                        </div>
                        <div className={styles['new-store-row']}>
                            <div className={styles['new-store-info-card']}>
                                <span className={styles['new-store-bold']}>
                                    Store Name
                                </span>
                                <div
                                    style={{
                                        fontSize: '15px',
                                        color: '#202223',
                                        fontWeight: '500',
                                        marginTop: '8px',
                                    }}
                                >
                                    {storeData?.store
                                        ? storeData?.store
                                        : 'Store Name Not Set'}
                                </div>
                            </div>

                            {/* Store Link Section Start */}
                            <div className={styles['new-store-info-card']}>
                                <span className={styles['new-store-bold']}>
                                    Store URLs
                                </span>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '10px',
                                        marginTop: '8px',
                                    }}
                                >
                                    {storeData && storeData.domain && (
                                        <div>
                                            <div
                                                style={{
                                                    fontSize: '12px',
                                                    color: '#6d7175',
                                                    marginBottom: '4px',
                                                }}
                                            >
                                                Custom Domain
                                            </div>
                                            <span
                                                className={
                                                    styles['new-store-url']
                                                }
                                            >
                                                {`${
                                                    storeData.DomainSSL === true
                                                        ? 'https://'
                                                        : 'http://'
                                                }${storeData?.domain}`}
                                            </span>
                                        </div>
                                    )}

                                    {storeData && storeData.SubDomain && (
                                        <div>
                                            <div
                                                style={{
                                                    fontSize: '12px',
                                                    color: '#6d7175',
                                                    marginBottom: '4px',
                                                }}
                                            >
                                                Subdomain
                                            </div>
                                            <span
                                                className={
                                                    styles['new-store-url']
                                                }
                                            >
                                                {`https://${storeData?.SubDomain}.ecomtechbd.com`}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Store Link Button Section Start */}
                            <div className={styles['new-store-info-card']}>
                                <span className={styles['new-store-bold']}>
                                    Quick Actions
                                </span>
                                {storeData && storeData.domain && (
                                    <Link
                                        to={`${
                                            storeData.DomainSSL === true
                                                ? 'https://'
                                                : 'http://'
                                        }${storeData?.domain}`}
                                        target="_blank"
                                        className={styles['new-store-button']}
                                    >
                                        Visit Domain
                                    </Link>
                                )}
                                {storeData && storeData.SubDomain && (
                                    <Link
                                        to={`https://${storeData?.SubDomain}.ecomtechbd.com`}
                                        target="_blank"
                                        className={styles['new-store-button']}
                                    >
                                        Visit Sub-Domain
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Store Section End */}

                    {/* Home page style (SiteEjs stores) */}
                    <HomeLayout storeData={storeData} uid={uid} onSaved={() => setRefresh((r) => !r)} />

                    {/* Home page sections: show/hide each product row */}
                    <HomeSections storeData={storeData} uid={uid} onSaved={() => setRefresh((r) => !r)} />

                    <div
                        className={styles['new-store-container']}
                        style={{ position: 'relative' }}
                    >
                        <div className={styles['new-store-add-domain-title']}>
                            <span className={styles['new-store-title']}>
                                Domain Settings
                            </span>
                            <button
                                onClick={() => setAddDomainModal(true)}
                                className={styles['new-store-add-domain-btn']}
                            >
                                + Add Domain
                            </button>
                        </div>

                        {storeData !== undefined && storeData.domain ? (
                            <>
                                {storeData.DomainSSL == false && (
                                    <div
                                        className={
                                            styles['new-store-add-domain-title']
                                        }
                                    >
                                        <p
                                            style={{
                                                color: '#fff',
                                                backgroundColor: '#ff4040',
                                                padding: '10px',
                                                borderRadius: '4px',
                                            }}
                                        >
                                            যদি আমাদের DNS সেট করে থাকেন {'( '}
                                            {nameservers.join(' এবং ')}{' '}
                                            {')'} Name Server অ্যাড করুন অথবা
                                            নিজের হোস্টিং থেকে যদি সাব ডোমেইন
                                            সেট করে থাকেন তাহলে ভেরিফাই করতে Add
                                            "A" record Host name - "@" IP
                                            address - "{primaryIP}" রেকর্ড টি
                                            করে ভেরিফাই বাটন এ ক্লিক করুন
                                        </p>
                                    </div>
                                )}
                                <div className={styles['new-store-content']}>
                                    <div
                                        className={
                                            styles['new-store-content-column']
                                        }
                                    >
                                        <div
                                            className={
                                                styles['new-store-content-row']
                                            }
                                        >
                                            <div
                                                className={
                                                    styles['new-store-side']
                                                }
                                            >
                                                Domain Name:
                                            </div>
                                            <div
                                                className={
                                                    styles['new-store-middle']
                                                }
                                            >
                                                {storeData?.domain}
                                            </div>
                                            <div
                                                className={
                                                    styles['new-store-middle']
                                                }
                                            >
                                                {storeData?.DomainSSL !==
                                                    undefined &&
                                                storeData?.DomainSSL ==
                                                    false ? (
                                                    <span
                                                        className={`${styles['new-store-badge']} ${styles['new-store-badge-warning']}`}
                                                    >
                                                        Not Verified
                                                    </span>
                                                ) : (
                                                    <span
                                                        className={`${styles['new-store-badge']} ${styles['new-store-badge-success']}`}
                                                    >
                                                        <FiCheck style={{verticalAlign:'middle'}} /> VERIFIED
                                                    </span>
                                                )}
                                            </div>

                                            {storeData.IsVerified !== 1 && (
                                                <button
                                                    disabled={loadingVerify}
                                                    className={`${
                                                        styles[
                                                            'new-store-button'
                                                        ]
                                                    } ${
                                                        loadingVerify
                                                            ? styles[
                                                                  'new-store-disabled-btn'
                                                              ]
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        handleVerify(
                                                            storeData?.domain
                                                        )
                                                    }
                                                >
                                                    {loadingVerify
                                                        ? 'Loading...'
                                                        : 'Verify Now'}
                                                </button>
                                            )}
                                            <button
                                                className={
                                                    styles[
                                                        'new-store-button-del'
                                                    ]
                                                }
                                                onClick={() =>
                                                    AlartSubmit(
                                                        storeData?.domain
                                                    )
                                                }
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div
                                className={
                                    styles['new-store-no-domain-available']
                                }
                            >
                                আপনার ডোমেইন থাকলে সেটি অ্যাড করতে পারবেন অথবা
                                আমাদের মাধ্যমে ডোমেইন কিনতে পারবেন । কি ভাবে
                                ডোমেইন সেট করবেন বা আমাদের মাধ্যমে কিনবেন এই
                                ভিডিও টি দেখুন <FiArrowRight style={{verticalAlign:'middle'}} />{' '}
                                <a href="#" target="_blank">
                                    VIDEO LINK
                                </a>
                            </div>
                        )}
                    </div>

                    <div className={styles['new-store-container']}>
                        <div className={styles['new-store-title']}>
                            Store Information
                        </div>
                        <div className={styles['new-store-content']}>
                            <div className={styles['new-store-content-column']}>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Store Logo: 2in X 0.8in or 0.8in X 0.8in
                                    </div>
                                    {storeData?.logo ? (
                                        <div
                                            className={
                                                styles['new-store-middle']
                                            }
                                        >
                                            <img
                                                src={storeData?.logo}
                                                height={70}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            className={
                                                styles['new-store-middle']
                                            }
                                        >
                                            আপনি কোনো লোগো সেট করেননি
                                        </div>
                                    )}

                                    <button
                                        className={styles['new-store-button']}
                                        onClick={() =>
                                            setDescriptionModal(true)
                                        }
                                    >
                                        Upload Logo
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Store Name:
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.store
                                            ? storeData?.store
                                            : 'Store Name Not Set'}
                                    </div>
                                    <button
                                        className={styles['new-store-button']}
                                        onClick={() =>
                                            setDescriptionModal(true)
                                        }
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        MetaTitle
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.metaTitle
                                            ? storeData?.metaTitle
                                            : 'Meta Title Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() =>
                                            setDescriptionModal(true)
                                        }
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        MetaDescription
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.metaDescription
                                            ? storeData?.metaDescription
                                            : 'Meta Description Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() =>
                                            setDescriptionModal(true)
                                        }
                                    >
                                        Change
                                    </button>
                                </div>

                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        MetaKeywords
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.metaKeywords
                                            ? storeData?.metaKeywords
                                            : 'Meta Keyword Not Set Example: best women bag, best sunglass for women, Etc use comma after every keyword'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() =>
                                            setDescriptionModal(true)
                                        }
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={
                                        styles['new-store-content-button']
                                    }
                                >
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => handleMeta()}
                                    >
                                        {loadingMeta
                                            ? 'Loading..'
                                            : 'Update Meta Tag'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles['new-store-container']}>
                        <div className={styles['new-store-title']}>Favicon</div>
                        <div className={styles['new-store-content']}>
                            <div className={styles['new-store-content-column']}>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Any image size (converted to {FAVICON_SIZE} × {FAVICON_SIZE} px)
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {faviconNote ? (
                                            <img
                                                src={faviconNote.preview}
                                                alt="New favicon preview"
                                                height={50}
                                                width={50}
                                            />
                                        ) : faviconUrl ? (
                                            <img
                                                src={faviconUrl}
                                                alt="Current favicon"
                                                height={50}
                                                width={50}
                                            />
                                        ) : (
                                            'No Favicon Uploaded'
                                        )}
                                    </div>
                                    <input
                                        id="ej-favicon-input"
                                        type="file"
                                        accept="image/*,.ico,.svg"
                                        onChange={handleFaviconChange}
                                        disabled={!!faviconBusy}
                                        className={styles['new-store-button']}
                                    />
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={handleFaviconUpload}
                                        disabled={!!faviconBusy}
                                        style={faviconBusy ? { opacity: 0.6, cursor: 'wait' } : undefined}
                                    >
                                        {faviconBusy === 'converting'
                                            ? 'Converting…'
                                            : faviconBusy === 'uploading'
                                              ? 'Uploading…'
                                              : 'Upload'}
                                    </button>
                                </div>
                                {faviconNote && (
                                    <div
                                        role="status"
                                        style={{
                                            fontSize: 13,
                                            lineHeight: 1.5,
                                            marginTop: 6,
                                            color: faviconNote.warn ? '#8a5300' : '#1b6e2a',
                                        }}
                                    >
                                        {faviconNote.notes.map((n) => (
                                            <div key={n}>{n}</div>
                                        ))}
                                        <div>Click Upload to save it.</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className={styles['new-store-container']}>
                        <div className={styles['new-store-title']}>
                            Contact Information
                        </div>
                        <div className={styles['new-store-content']}>
                            <div className={styles['new-store-content-column']}>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Mobile
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.number
                                            ? storeData?.number
                                            : 'Mobile Number Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Email
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.Email
                                            ? storeData?.Email
                                            : 'Email Address Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Address
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.Address
                                            ? storeData?.Address
                                            : 'Address Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        WhatsApp
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {' '}
                                        {storeData?.WhatsApp
                                            ? storeData?.WhatsApp
                                            : 'WhatsApp Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Messanger Url
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.MessangerUrl
                                            ? storeData?.MessangerUrl
                                            : 'Messanger Url Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Facebook Page Url
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {' '}
                                        {storeData?.FacebookUrl
                                            ? storeData?.FacebookUrl
                                            : 'Facebook Page Url Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        YouTube Url
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {' '}
                                        {storeData?.YouTubeUrl
                                            ? storeData?.YouTubeUrl
                                            : 'YouTube Url Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Instagram Url
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.InstagramUrl
                                            ? storeData?.InstagramUrl
                                            : 'Instagram Url Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        TikTok Url
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.TikTok
                                            ? storeData?.TikTok
                                            : 'TikTok Url Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Linkedin Url
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.Linkedin
                                            ? storeData?.Linkedin
                                            : 'Linkedin Url Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setContactModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles['new-store-container']}>
                        <div className={styles['new-store-title']}>
                            Delivery Charges
                        </div>
                        <div className={styles['new-store-content']}>
                            <div className={styles['new-store-content-column']}>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Outside Dhaka
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {' '}
                                        {storeData?.Outside
                                            ? storeData?.Outside
                                            : 'Delivery Charge Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setDeliveryModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Inside Dhaka
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.Dhaka
                                            ? storeData?.Dhaka
                                            : 'Delivery Charge Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setDeliveryModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className={styles["new-store-title"]}>Store Payment Number</div>
        <div className={styles["new-store-container"]}>
          <div className={styles["new-store-content"]}>
            <div className={styles["new-store-content-column"]}>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Bkash</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.Bkash ? storeData?.Bkash : "Bkash Number Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setBNRModal(true)}
                >
                  Change
                </button>
              </div>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Rocket</div>
                <div className={styles["new-store-middle"]}>
                  {" "}
                  {storeData?.Rocket
                    ? storeData?.Rocket
                    : "Rocket Number Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setBNRModal(true)}
                >
                  Change
                </button>
              </div>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Nagad</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.Nagad ? storeData?.Nagad : "Nagad Number Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setBNRModal(true)}
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div> */}

                    {/* <div className={styles["new-store-title"]}>Bkash Payment API</div>
        <div className={styles["new-store-container"]}>
          <div className={styles["new-store-content"]}>
            <div className={styles["new-store-content-column"]}>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Bkash API Key</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.BkashAPIKey
                    ? storeData?.BkashAPIKey
                    : "Bkash Api Key Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setBkashApiModal(true)}
                >
                  Change
                </button>
              </div>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Bkash Secret Key</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.BkashSecret
                    ? storeData?.BkashSecret
                    : "Bkash Api Secret Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setBkashApiModal(true)}
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div> */}

                    {/* <div className={styles["new-store-title"]}>Rocket Payment API</div>
        <div className={styles["new-store-container"]}>
          <div className={styles["new-store-content"]}>
            <div className={styles["new-store-content-column"]}>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Rocket Api Key:</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.RocketAPIKey
                    ? storeData?.RocketAPIKey
                    : "Rocket Api Key Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setRocketApiModal(true)}
                >
                  Change
                </button>
              </div>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Rocket Secret Key:</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.RocketSecret
                    ? storeData?.RocketSecret
                    : "Rocket Api Secret Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setRocketApiModal(true)}
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div> */}

                    {/* <div className={styles["new-store-title"]}>Nagad Payment API</div>
        <div className={styles["new-store-container"]}>
          <div className={styles["new-store-content"]}>
            <div className={styles["new-store-content-column"]}>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Nagad API Key:</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.NagadAPIKey
                    ? storeData?.NagadAPIKey
                    : "Nagad Api Key Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setNagadApiModal(true)}
                >
                  Change
                </button>
              </div>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Nagad Secret Key:</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.NagadSecret
                    ? storeData?.NagadSecret
                    : "Nagad Api Secret Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setNagadApiModal(true)}
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div> */}

                    {/* <div className={styles["new-store-title"]}>Pathao Courier API</div>
        <div className={styles["new-store-container"]}>
          <div className={styles["new-store-content"]}>
            <div className={styles["new-store-content-column"]}>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Pathao API Key</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.PathaoAPIKey
                    ? storeData?.PathaoAPIKey
                    : "Pathao Api Key Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setPathaoApiModal(true)}
                >
                  Change
                </button>
              </div>
              <div className={styles["new-store-content-row"]}>
                <div className={styles["new-store-side"]}>Pathao Secret Key</div>
                <div className={styles["new-store-middle"]}>
                  {storeData?.PathaoSecret
                    ? storeData?.PathaoSecret
                    : "Pathao Api Secret Not Set"}
                </div>
                <button
                  type="button"
                  className={styles["new-store-button"]}
                  onClick={() => setPathaoApiModal(true)}
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div> */}

                    <div className={styles['new-store-container']}>
                        <div className={styles['new-store-title']}>
                            SteadFast Courier API
                        </div>
                        <div className={styles['new-store-content']}>
                            <div className={styles['new-store-content-column']}>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        SteadFast API Key:
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.SteadFastAPIKey
                                            ? storeData?.SteadFastAPIKey
                                            : 'SteadFast Api Key Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() =>
                                            setSteadFastApiModal(true)
                                        }
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        SteadFast Secret Key:
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.SteadFastSecret
                                            ? storeData?.SteadFastSecret
                                            : 'SteadFast Api Secret Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() =>
                                            setSteadFastApiModal(true)
                                        }
                                    >
                                        Change
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles['new-store-container']}>
                        <div className={styles['new-store-title']}>
                            Analytics & Tracking
                        </div>
                        <div className={styles['new-store-content']}>
                            <div className={styles['new-store-content-column']}>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        FacebookPixel
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {' '}
                                        {storeData?.pixel
                                            ? storeData?.pixel
                                            : 'FaceBook Pixel Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setTrackingModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        FaceBook Conversions API
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {' '}
                                        {storeData?.FAccessToken
                                            ? storeData?.FAccessToken.substring(
                                                  0,
                                                  30
                                              ) + '...'
                                            : 'Access Token Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setTrackingModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Google Analytic
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.GoogleAnalytic
                                            ? storeData?.GoogleAnalytic
                                            : 'Google Analytic Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setTrackingModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                                <div
                                    className={styles['new-store-content-row']}
                                >
                                    <div className={styles['new-store-side']}>
                                        Google Ads Tag
                                    </div>
                                    <div className={styles['new-store-middle']}>
                                        {storeData?.GoogleAdsTag
                                            ? storeData?.GoogleAdsTag
                                            : 'Google Ads Tag Not Set'}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['new-store-button']}
                                        onClick={() => setTrackingModal(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <Policy /> */}
                </div>
            </div>
            )}
        </>
    );
}

export default NewStore;
